var CirculosMapas = function(el, datos, total, callback) {
  var debug = false;

  var altoVisualizacion = 0;

  var ladoMapa = 400;
  var offsetY = 60;

  var aux = {
    top: 10,
    right: 10,
    bottom: 10,
    left: 10
  };

  (function() {
    var max = 0;
    _.each(datos.extras, function(e) {
      e.opciones = _.filter(e.opciones, function(o) {
        return o.valor > 0;
      });
      max = _.max([max, e.opciones.length]);
    });
    var config = new Config(0, aux);
    var circulos = config.getCirculos();

    altoVisualizacion = ladoMapa + 20 + circulos.radio * 2 + offsetY * max + 20;

    var margin = config.getMargin();
    var gMargin = config.getGMargin();
    altoVisualizacion +=
      margin.top + margin.bottom + gMargin.top + gMargin.bottom;
  })();

  var config = new Config(altoVisualizacion, aux);

  var margin = config.getMargin();
  var medidas = config.getMedidas();

  var gMargin = config.getGMargin();
  var gMedidas = config.getGMedidas();

  var circulos = config.getCirculos();

  var contenedor = null;
  var svg = null;
  var gGrafica = null;

  var grupos = null;

  function setup() {
    contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      el.data("visualizacion", true);
      contenedor.selectAll("svg").remove();
      svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr(
          "viewBox",
          "0 0 " +
            (medidas.ancho + margin.left + margin.right) +
            " " +
            (medidas.alto + margin.top + margin.bottom)
        );

      el.attr("data-setup", true);

      if (debug === true) {
        svg
          .append("rect")
          .attr("fill", "yellow")
          .attr("opacity", 0.5)
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", medidas.ancho + margin.left + margin.right)
          .attr("height", medidas.alto + margin.top + margin.bottom);
      }

      svg = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      if (debug === true) {
        svg
          .attr("class", "svg")
          .append("rect")
          .attr("width", medidas.ancho + (margin.right - margin.left))
          .attr("height", medidas.alto)
          .attr("fill", "blue")
          .attr("opacity", 0.5);
      }

      gGrafica = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + gMargin.left + "," + gMargin.top + ")"
        );

      if (debug === true) {
        gGrafica
          .attr("class", "gGrafica")
          .append("rect")
          .attr("width", gMedidas.ancho)
          .attr("height", gMedidas.alto)
          .attr("fill", "red")
          .attr("opacity", 0.5);
      }
      main();
    }
  }

  function main() {
    var f = d3.queue();
    _.each(datos.extras, function(e) {
      f.defer(convertImgToBase64URL, e);
    });
    f.awaitAll(function(error, a) {
      setCirculos();
      setMapas();
      funciones.generaTooltips(gGrafica.selectAll("path.transporte"));
      el.removeClass("espera");
      iniciar();
    });
  }

  function revisaScroll() {
    if (debug === true) {
      iniciar();
      $(window).off("scroll", revisaScroll);
    } else {
      if (el.visible(true) === true) {
        iniciar();
        $(window).off("scroll", revisaScroll);
      }
    }
  }

  function iniciar() {
    actualizaCirculos();
    callback(null, true);
  }

  function setMapas() {
    grupos
      .append("image")
      .attr("x", function(d, i) {
        var x = i % 2 === 0 ? 0 : gMedidas.ancho / 2 - ladoMapa;
        return x;
      })
      .attr("y", 0)
      .attr("width", ladoMapa)
      .attr("height", ladoMapa)
      .attr("xlink:href", function(d) {
        return d.mapab64;
      });
  }

  function actualizaCirculos() {
    grupos
      .selectAll("text.valor")
      .attr("opacity", 0)
      .transition()
      .duration(800)
      .attr("opacity", 1);
  }

  function setCirculos() {
    var ancho = ladoMapa - (circulos.radio * 2 + 30);

    var pcts = funciones.getPorcentajes(_.map(datos.extras, "valor"), total);
    _.each(pcts, function(p, i) {
      datos.extras[i].valor = pcts[i];
      var subarreglo = datos.extras[i].opciones || [];
      var subtotal = subarreglo.length > 0 ? _.sumBy(subarreglo, "valor") : 0;
      var subpcts = funciones.getPorcentajes(
        _.map(subarreglo, "valor"),
        subtotal
      );
      _.each(subpcts, function(q, j) {
        subarreglo[j].valor = subpcts[j];
      });
      subarreglo = _.orderBy(
        subarreglo,
        ["valor", "etiqueta"],
        ["desc", "asc"]
      );
      datos.extras[i].opciones = subarreglo;
    });

    grupos = gGrafica
      .selectAll("g.contenedorgrupo")
      .data(datos.extras)
      .enter()
      .append("g")
      .attr("class", "contenedorgrupo")
      .attr("transform", function(d, i) {
        return "translate(" + (gMedidas.ancho * i) / 2 + ",0)";
      });

    grupos
      .append("circle")
      .each(function(d, i) {
        var x =
          i % 2 === 0
            ? circulos.radio
            : gMedidas.ancho / 2 + circulos.radio - ladoMapa;
        var y = circulos.radio + ladoMapa + 20;
        d.coords = { x: x, y: y };
      })
      .attr("cx", function(d, i) {
        return d.coords.x;
      })
      .attr("cy", function(d, i) {
        return d.coords.y;
      })
      .attr("r", circulos.radio)
      .style(circulos.estiloCirculo);

    grupos
      .append("text")
      .attr("class", "valor")
      .attr("opacity", 0)
      .attr("x", function(d) {
        return d.coords.x;
      })
      .attr("y", function(d) {
        return d.coords.y;
      })
      .style(circulos.estiloTexto)
      .text(function(d) {
        var v = parseInt(d.valor);
        if (v < 1) {
          v = "<1";
        }
        return v + "%";
      });

    grupos
      .append("text")
      .style(circulos.estiloLeyenda)
      .style("text-anchor", "start")
      .style("dominant-baseline", "alphabetic")
      .attr("x", function(d) {
        return d.coords.x + circulos.radio + 10;
      })
      .attr("y", function(d) {
        return d.coords.y;
      })
      .text(function(d) {
        return d.etiqueta;
      })
      .call(funciones.wrap, ancho);

    grupos.each(function(d) {
      var opciones = d.opciones || false;

      if (opciones !== false) {
        var grupo = d3.select(this);

        var x = 40;
        var yIni = ladoMapa + circulos.radio * 2;

        grupo
          .append("line")
          .attr("x1", function(d) {
            return d.coords.x;
          })
          .attr("y1", function(d) {
            return d.coords.y + circulos.radio;
          })
          .attr("x2", function(d) {
            return d.coords.x;
          })
          .attr("y2", function(d) {
            return d.coords.y + offsetY * d.opciones.length + circulos.radio;
          })
          .style(circulos.estiloLinea);

        var subgrupos = grupo
          .selectAll("g.contenedorsubgrupo")
          .data(d.opciones)
          .enter()
          .append("g")
          .attr("class", "contenedorsubgrupo")
          .attr("transform", function(d, i) {
            return "translate(" + x + "," + (yIni + offsetY * i) + ")";
          });

        subgrupos
          .append("line")
          .attr("x1", x + 30)
          .attr("y1", 80)
          .attr("x2", x + 40)
          .attr("y2", 80)
          .style(circulos.estiloLinea);

        subgrupos
          .append("text")
          .attr("class", "valor")
          .attr("opacity", 0)
          .attr("x", 150)
          .attr("y", 80)
          .style(circulos.estiloTexto)
          .style("text-anchor", "end")
          .text(function(d) {
            var v = parseInt(d.valor);
            if (v < 1) {
              v = "<1";
            }
            return v + "%";
          });

        subgrupos
          .append("text")
          .style(circulos.estiloLeyenda)
          .style("text-anchor", "start")
          .style("dominant-baseline", "alphabetic")
          .attr("x", 160)
          .attr("y", 86)
          .text(function(d) {
            return d.etiqueta;
          })
          .call(funciones.wrap, ancho - 50);
      }
    });
  }

  function convertImgToBase64URL(d, callback) {
    var img = new Image();
    img.onload = function() {
      var canvas = document.createElement("CANVAS"),
        ctx = canvas.getContext("2d"),
        dataURL;
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      dataURL = canvas.toDataURL("image/png");
      d.mapab64 = dataURL;
      canvas = null;
      callback(null, d);
    };
    d.img = d.mapa;
    img.src = d.img;
  }

  setup();
};
